module.exports = __webpack_public_path__ + "img/gallery-2.1d311911.webp";